<template>
    <div>
      <!-- 纸质单据内容 -->
      <button @click="printDocument">{{$t('pages.handover.print')}}</button>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      printDocument() {
        const printContent = document.getElementById('document-content').innerHTML;
  
        const printWindow = window.open('', '_blank');
        printWindow.document.open();
        printWindow.document.write(`
          <html>
            <head>
              <title>${this.$t('pages.handover.printTitle')}</title>
              <style>
                /* 打印样式 */
                @media print {
                  /* 样式和布局设置 */
                }
              </style>
            </head>
            <body>
              ${printContent}
            </body>
          </html>
        `);
        printWindow.document.close();
  
        printWindow.onload = function() {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        };
      }
    }
  };
  </script>
  
